// src/data/pharmacistMockData.js

export const messageMockData = [
  {
    id: 1,
    sender: 'Doctor',
    subject: 'Prescription Update',
    content: 'Please review the updated prescription for John Doe.',
    date: '2023-09-01',
    status: 'Received',
  },
  {
    id: 2,
    sender: 'Supplier',
    subject: 'Stock Replenishment',
    content: 'Your order for Fluoxetine has been shipped.',
    date: '2023-08-31',
    status: 'Received',
  },
  {
    id: 3,
    sender: 'Pharmacy Staff',
    subject: 'Inventory Alert',
    content: 'Low stock alert for Lorazepam.',
    date: '2023-08-30',
    status: 'Sent',
  },
];
